export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const KEY = '9b94c43e-e561-40c7-b94e-9c8c493ac181';